import { FieldErrors, FieldValues, Path } from "react-hook-form";

export function getFormError<T extends FieldValues>(
	name: Path<T>,
	errors: FieldErrors<T>,
): string | undefined {
	const arrayName = name.split(".");

	let error: any = errors;
	for (let i = 0; i < arrayName.length; i++) {
		if (!error[arrayName[i]]) {
			return undefined;
		}
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		error = error[arrayName[i]];
	}

	return error.message;
}
